import { useTranslation } from "react-i18next";
import { BoldText, CruiseSubHeader, CruiseWrapper, Description, ListItem, ListTitle, StyledList } from "../styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { LINKS } from "../../../config/links";

const Houses = () => {
    const { t } = useTranslation("houses");

    const offerItems = t("sections.offer.items", { returnObjects: true });
    const attractionsItems = t("sections.attractions.items", { returnObjects: true });

    const renderList = (items) => (
        <StyledList>
            {items.map((item, idx) => (
                <ListItem key={idx}>
                    <BoldText>{item.label} </BoldText>
                    {item.text}
                </ListItem>
            ))}
        </StyledList>
    );

    return (
        <CruiseWrapper id={LINKS.sections.housesDescription}>
            <StaggeredContainer>
                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.equipment.title")}</CruiseSubHeader>
                </StaggeredItem>

                <StaggeredItem>
                    <Description>{t("sections.equipment.intro")}</Description>
                </StaggeredItem>

                <StaggeredItem>
                    <ListTitle>{t("sections.offer.title")}</ListTitle>
                </StaggeredItem>

                <StaggeredItem>{renderList(offerItems)}</StaggeredItem>

                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.terrace.title")}</CruiseSubHeader>
                </StaggeredItem>

                <StaggeredItem>
                    <Description>{t("sections.terrace.text")}</Description>
                </StaggeredItem>

                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.location.title")}</CruiseSubHeader>
                </StaggeredItem>

                <StaggeredItem>
                    <Description>{t("sections.location.text")}</Description>
                </StaggeredItem>

                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.attractions.title")}</CruiseSubHeader>
                </StaggeredItem>

                <StaggeredItem>
                    <ListTitle>{t("sections.attractions.subtitle")}</ListTitle>
                    {renderList(attractionsItems)}
                </StaggeredItem>
            </StaggeredContainer>
        </CruiseWrapper>
    );
};

export default Houses;